import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ApiKeyState {
    apiKey: string | null;
    environment: string;
}

const initialState: ApiKeyState = {
    apiKey: null,
    environment: import.meta.env.VITE_SE_ENVIRONMENT || "production",
};

const apiKeySlice = createSlice({
    name: "apiKey",
    initialState,
    reducers: {
        setApiKey(state, action: PayloadAction<string>) {
            state.apiKey = action.payload;
        },
        setEnvironment(state, action: PayloadAction<string>) {
            state.environment = action.payload;
        },
    },
});

export const { setApiKey, setEnvironment } = apiKeySlice.actions;
export default apiKeySlice.reducer;
